// src/utils/parseScenes.js

// Match tolérant de headings de scènes
const HEADING_RE =
  /^(?:\s*(?:\d+[A-Za-z]?\s*[-.]\s*)?(?:(?:SC[ÈE]NE|SCENE)\s*.*|#\s+.*)\s*|\s*(?:\d+[A-Za-z]?\s*[-.]?\s*)?(?:\.?\s*)?(?:(?:INT\.\/EXT\.|INT\/EXT|I\/E|INT\.|EXT\.|INT|EXT))\s*(?:[.:\-]\s*)?.*)$/gim;

function normalizeTitle(rawLine) {
  let line = (rawLine ?? "").trim();
  line = line.replace(/^#\s+/, "");
  line = line.replace(/^\.\s*/, "");
  // enlève un numéro de scène en tête ("1A - ", "7B. ", "12 ") — avec ou sans séparateur
  line = line.replace(/^\d+\s*[A-Za-z]?\s*[-.:]?\s+/, "");
  // enlève un numéro de scène Fountain en fin de ligne (#1A#)
  line = line.replace(/\s*#\s*\d+\s*[A-Za-z]?\s*#\s*$/, "");
  return line.trim();
}

// Extrait le numéro de scène tel qu'écrit dans le scénario (ex: "1", "1A", "7B", "12").
// Retourne "" si aucun numéro n'est trouvé (on retombera alors sur l'index).
export function extractSceneNumber(rawHeadingLine) {
  const line = (rawHeadingLine ?? "").toString().trim();
  if (!line) return "";

  const clean = (s) => s.replace(/\s+/g, "").toUpperCase();

  // Fountain : numéro de scène en fin de ligne entre # … # (ex: "INT. CUISINE - JOUR #1A#")
  let mf = line.match(/#\s*(\d+\s*[A-Za-z]?)\s*#\s*$/);
  if (mf) return clean(mf[1]);

  // "SCÈNE 12A" / "SCENE 3" / "SÉQUENCE 7B" / "SEQ 2" (avec éventuel "N°")
  let m = line.match(
    /^#?\s*(?:SC[ÈE]NE|SCENE|S[ÉE]QUENCE|S[ÉE]Q)\s*(?:N[°O]\s*\.?\s*)?(\d+\s*[A-Za-z]?)\b/i
  );
  if (m) return clean(m[1]);

  // Numéro en tête devant INT/EXT : "12A INT.", "7B - EXT", "3. INT"
  m = line.match(/^#?\s*(\d+\s*[A-Za-z]?)\s*[-.:]?\s*(?:INT|EXT|I\/E)\b/i);
  if (m) return clean(m[1]);

  // Numéro générique en tête de ligne : "12A CUISINE"
  m = line.match(/^#?\s*(\d+\s*[A-Za-z]?)\b/);
  if (m) return clean(m[1]);

  return "";
}

// Libellé de scène à afficher : numéro du scénario si présent, sinon index+1.
export function getSceneNumberLabel(scene, index) {
  const raw = String(scene?.number ?? "").trim();
  if (raw) return raw;
  return String((Number(index) || 0) + 1);
}

export function parseScenes(scriptText) {
  const text = scriptText ?? "";
  if (!text.trim()) return [];

  const matches = Array.from(text.matchAll(HEADING_RE));

  if (matches.length === 0) {
    return [
      {
        id: "scene_0",
        title: "Scène 1",
        number: "",
        start: 0,
        end: text.length,
      },
    ];
  }

  const scenes = [];
  for (let i = 0; i < matches.length; i++) {
    const m = matches[i];
    const start = m.index ?? 0;
    const nextStart = matches[i + 1]?.index ?? text.length;

    scenes.push({
      id: `scene_${start}`, // 👈 stable
      title: normalizeTitle(m[0]),
      number: extractSceneNumber(m[0]), // 👈 numéro tel qu'écrit dans le scénario
      start,
      end: Math.max(start, nextStart),
    });
  }

  return scenes;
}
